import { domainRegex } from './regex';

export const getUrlWithNajizDomain = (url: string) => {
  const isNajizDomain = url.includes('najiz');

  return isNajizDomain ? url.replace(domainRegex, location.origin) : url;
};

export const isEmptyObject = (obj: any): boolean => {
  if (obj === null) {
    return false;
  }

  return Object.keys(obj).length === 0;
};

export const getTotalHeight = (element: HTMLElement | null): number => {
  if (!element) {
    return 0;
  }

  const styles = window.getComputedStyle(element);
  const marginTop = parseFloat(styles.marginTop);
  const marginBottom = parseFloat(styles.marginBottom);
  // ? including paddings
  const elementHeight = element.offsetHeight;

  return elementHeight + marginTop + marginBottom;
};

export const getDirectionMeta = () => {
  const language = (document.getElementById('lang_placeholder') as HTMLInputElement)?.value || 'ar';

  return {
    language,
    isRTL: language === 'ar',
  };
};
export const isBetweenDates = (startDate: string, endDate: string) => {
  const today = new Date();

  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);

  const startDateInstance = new Date(startDate);
  const endDateInstance = new Date(endDate);
  const isAvailable = today >= startDateInstance && today < endDateInstance;

  return isAvailable;
};

export const isCurrentlyNationalDay = () => {
  const { startDate, endDate } = window.$config.nationalDay || {
    startDate: '',
    endDate: '',
  };

  return isBetweenDates(startDate, endDate);
};

export const isCurrentlyFoundingDay = () => {
  const { startDate, endDate } = window.$config.foundingDay || {
    startDate: '',
    endDate: '',
  };

  return isBetweenDates(startDate, endDate);
};

export const isCurrentlyHajjPeriod = () => {
  const { startDate, endDate } = window.$config.hajjPeriod || {
    startDate: '',
    endDate: '',
  };

  return isBetweenDates(startDate, endDate);
};
